<template>
    <div class="list-avatar-card">
        <div class="card">
            <slot name="header">
                <div class="card-header" v-html="header"></div>
            </slot>

            <div class="card-body d-flex flex-column">

                <slot name="body">

                    <ul v-if="items.length" class="list-none p-0 m-0">
                        <li v-for="(item, iindex) in items" :key="iindex" class="mb-4 d-flex align-items-center">
                            <div
                                class="p-avatar p-component p-avatar-circle p-avatar-lg fw-bold"
                                :style="
                                    `background-color: rgba(${colors[iindex]}, 0.1);
                                    color: rgb(${colors[iindex]});
                                    border: 1px solid rgb(${colors[iindex]});`
                                "
                            >
                                <span class="p-avatar-text">
                                    <template v-if="item.image && item.image != ''">
                                        <img :src="item.image" />
                                    </template>
                                    <template v-else-if="item.icon && item.icon != ''">
                                        <i :class="item.icon"></i>
                                    </template>
                                    <template v-else>{{ item.title[0] }}{{ item.title.split(' ')[1][0] }}</template>
                                </span>
                            </div>
                            <div class="ms-3">
                                <span class="d-block">{{ item.title }}</span>
                                <span class="text-color-secondary d-block">{{ item.subtitle }}</span>
                            </div>
                        </li>
                    </ul>

                    <button v-if="items.length" class="btn btn-primary w-full">View All <i class="fas fa-arrow-right ms-2"></i></button>

                </slot>

            </div>

            <slot name="footer">
                <div class="card-footer" v-html="footer"></div>
            </slot>

        </div>
    </div>
</template>


<script>
export default {
    name: 'ListAvatarCard',
    props: {
        header:{
            type: String,
            default: ''
        },
        subtitle:{
            type: String,
            default: ''
        },
        items:{
            type: Array,
            default(){
                return [];
            }
        },
        colors:{
            type: Array,
            default(){
                return [];
            }
        },
        footer:{
            type: String,
            default: ''
        },
    },
    setup() {
        return {};
    },
}
</script>


<style lang="scss">
.list-avatar-card{
    width: 100%;
    height: 100%;

    .list-none{
        list-style: none;
    }

    .card{
        border: 0px;
        border-radius: 10px;
        padding: 10px;
        height: 100%;
        width: 100%;
    }
    .card-header{
        background-color: unset;
        border: 0px;
        font-size: 1rem;
        font-weight: 600;
    }
    .card-footer{
        background-color: unset;
        border: 0px;
    }
}
</style>